import styled from '@emotion/styled'

export const Row = styled.div<{inverse?: boolean}>`
  display: flex;
  gap: 0.5rem;
  flex-direction: ${(props) => (props.inverse ? 'row-reverse' : 'row')};
`
